export enum AWSRegionType {
    Europe = 'Europe',
    Singapore = 'Singapore',
}

export const AWSRegionTypeMap: Record<string, string> = {
    eu: AWSRegionType.Europe,
    sg: AWSRegionType.Singapore,
};
